export default {
  selectedOptionColor: '',
  selectionOptionsSeparatorColor: Styles.color.grey.three,
  checkIconFillColor: Styles.color.grey.three,
  selectionOptionsRequiredBackgroundColor: Styles.color.tertiary,
};
